import {
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';
import { VenueCompsTableRowType } from '../../data';

type VenueCompsTableRowPropsType = {
  venueComps: string | null;
  row: VenueCompsTableRowType;
};
export const VenueCompsTableRow: React.FC<VenueCompsTableRowPropsType> = ({
  venueComps,
  row,
}) => {
  const { t } = useTranslation('venueDetailsOverview');

  const label = t(`VENUE_COMPS.ROWS.${row.label}`);

  const getRenderValue = () => {
    if (!venueComps) return t('NO_DATA_PLACEHOLDER', { ns: 'common' });
    return venueComps;
  };

  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>{label}</TouringCardTableRowLabel>
      <TouringCardTableRowValue>{getRenderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};

